import type { AllHopsPlacements } from '../types/genericTypes';

export const ompNewLaneProps: Record<
    AllHopsPlacements,
    { triggerObject: string; triggerLocation: string; triggerSource: string }
> = {
    HomePageHeroImage: {
        triggerObject: 'no_trigger_object',
        triggerLocation: 'home',
        triggerSource: 'hero_image',
    },
    HomePageRTBCard1: {
        triggerObject: 'home|rtb1',
        triggerLocation: 'home',
        triggerSource: 'rtb1',
    },
    HomePageRTBCard2: {
        triggerObject: 'home|rtb2',
        triggerLocation: 'home',
        triggerSource: 'rtb2',
    },
    HomePageRTBCard3: {
        triggerObject: 'home|rtb3',
        triggerLocation: 'home',
        triggerSource: 'rtb3',
    },
    HomePageBanner: {
        triggerObject: 'home|banner',
        triggerLocation: 'home',
        triggerSource: 'banner',
    },
    HomePageTopSlot: {
        triggerObject: 'home|top',
        triggerLocation: 'home',
        triggerSource: 'top',
    },
    HomePageStickySlot: {
        triggerObject: 'home|sticky',
        triggerLocation: 'home',
        triggerSource: 'sticky',
    },
};
